import { render, staticRenderFns } from "./AddDescriptionModal.vue?vue&type=template&id=49fd1cc9&scoped=true&"
import script from "./AddDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./AddDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDescriptionModal.vue?vue&type=style&index=0&id=49fd1cc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd1cc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VForm,VTextField,VTextarea})
